import { render, staticRenderFns } from "./tab-main-info.vue?vue&type=template&id=690796ed&"
import script from "./tab-main-info.vue?vue&type=script&lang=js&"
export * from "./tab-main-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports